const { background } = require('@storybook/theming');

const secondaryButtonStyles = theme => ({
  '.btn-classic-secondary': {
    backgroundColor: theme('colors.white'),
    color: theme('colors.green1.55'),
    // Use box-shadow instead of border to avoid affecting overall size
    border: 'none',
    boxShadow: `inset 0px 0px 0px 1px ${theme('colors.green1.55')}`,

    'a&:hover, a&:focus': {
      color: theme('colors.green1.60'),
    },
    '&:hover, &:focus': {
      boxShadow: `inset 0px 0px 0px 2px ${theme('colors.green1.60')}`,
    },

    '&:active:enabled': {
      backgroundColor: theme('colors.green1.65'),
      boxShadow: 'none',
      color: theme('colors.white'),
    },

    '&.disabled': {
      color: theme('colors.green1.30'),
      boxShadow: `inset 0px 0px 0px 1px ${theme('colors.green1.30')}`,
    },
  },

  '.btn-classic-secondary-ghost': {
    backgroundColor: 'transparent',
    color: theme('colors.green1.10'),
    border: 'none',
    boxShadow: `inset 0px 0px 0px 1px ${theme('colors.green1.10')}`,

    'a&:hover, a&:focus': {
      color: theme('colors.green1.15'),
    },
    '&:hover, &:focus': {
      boxShadow: `inset 0px 0px 0px 2px ${theme('colors.green1.15')}`,
    },

    '&:active:enabled': {
      backgroundColor: theme('colors.green1.10'),
      boxShadow: 'none',
      color: theme('colors.green1.60'),
    },

    '&.disabled': {
      color: theme('colors.green1.35'),
      boxShadow: `inset 0px 0px 0px 1px ${theme('colors.green1.35')}`,
    },
  },

  '.btn-classic-secondary-ghost-dark': {
    backgroundColor: 'transparent',
    color: theme('colors.green1.55'),
    border: 'none',
    boxShadow: `inset 0px 0px 0px 1px ${theme('colors.green1.55')}`,

    'a&:hover, a&:focus': {
      color: theme('colors.green1.55'),
    },
    '&:hover, &:focus': {
      boxShadow: `inset 0px 0px 0px 2px ${theme('colors.green1.55')}`,
    },

    '&:active:enabled': {
      backgroundColor: theme('colors.green1.15'),
      boxShadow: 'none',
      color: theme('colors.green1.60'),
    },

    '&.disabled': {
      color: theme('colors.green1.30'),
      boxShadow: `inset 0px 0px 0px 1px ${theme('colors.green1.30')}`,
    },
  },

  '.btn-classic-secondary-ghost-alert': {
    backgroundColor: 'transparent',
    color: theme('colors.alertred.60'),
    border: 'none',
    boxShadow: `inset 0px 0px 0px 1px ${theme('colors.alertred.60')}`,

    'a&:hover, a&:focus': {
      color: theme('colors.alertred.60'),
    },

    '&:hover, &:focus': {
      boxShadow: `inset 0px 0px 0px 2px ${theme('colors.alertred.60')}`,
    },

    '&:active:enabled': {
      boxShadow: `inset 0px 0px 0px 2px ${theme('colors.alertred.60')}`,
      background: 'transparent',
      color: theme('colors.alertred.60'),
    },

    '&.disabled': {
      color: theme('colors.green1.30'),
      boxShadow: `inset 0px 0px 0px 1px ${theme('colors.grey.40')}`,
    },
  },
});

module.exports = { secondaryButtonStyles };
